type Fields<T> = {
  [K in keyof T as T[K] extends undefined ? never : K]: T[K];
};

// 빈 값 체크 함수들
const isUndefined = (value: unknown): boolean => value === undefined;

const isEmptyString = (value: unknown): boolean =>
  typeof value === "string" && value.trim() === "";

const isEmptyArray = (value: unknown): boolean =>
  Array.isArray(value) && value.length === 0;

const isEmptyObject = (value: unknown): boolean =>
  typeof value === "object" &&
  value !== null &&
  !Array.isArray(value) &&
  Object.keys(value).length === 0;

// 최종적으로 빈 값인지 검사하는 함수
function isEmpty(value: unknown): boolean {
  return (
    isUndefined(value) ||
    isEmptyString(value) ||
    isEmptyArray(value) ||
    isEmptyObject(value)
  );
}

function removeEmptyFields<T extends Record<string, unknown>>(
  obj: T,
): Fields<T> {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(obj)) {
    if (!isEmpty(value)) {
      result[key] = value;
    }
  }

  return result as Fields<T>;
}

export default removeEmptyFields;
